import {TableCell, TableHead, TableRow, Typography} from "@mui/material";

export const BetboardTableHeaders = ({sport}: {sport: string}) => {
    return (
        <TableHead>
            <TableRow sx={{ '& > *': { paddingTop: '4px !important', paddingBottom: '4px !important' }}}>
                <TableCell align="left">
                    <Typography style={{fontWeight: '600'}} variant="caption">
                        Start Time (EST)
                    </Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography style={{fontWeight: '600'}} variant="caption">
                        Home (Listed) - Line {sport === 'mlb' && ' - Run Line'}
                    </Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography style={{fontWeight: '600'}} variant="caption">
                        Opponent - Opp. Line {sport === 'mlb' && ' - Run Line'}
                    </Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography style={{fontWeight: '600'}} variant="caption">
                        Total
                    </Typography>
                </TableCell>
            </TableRow>
        </TableHead>
    )
}